import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** The `Byte` scalar type represents non-fractional whole numeric values. Byte can represent values between 0 and 255. */
  Byte: any;
  /** The `DateTime` scalar represents an ISO-8601 compliant date time type. */
  DateTime: any;
  HierarchyId: any;
  /** The `Long` scalar type represents non-fractional signed whole 64-bit numeric values. Long can represent values between -(2^63) and 2^63 - 1. */
  Long: any;
  /** The `TimeSpan` scalar represents an ISO-8601 compliant duration type. */
  TimeSpan: any;
  UUID: any;
};

export type AcdAttendantGroup = {
  __typename?: 'AcdAttendantGroup';
  groups: Array<Group>;
};

export type ActivityDiversion = {
  __typename?: 'ActivityDiversion';
  destination: Destination;
  eveUserId: Scalars['Int'];
  eveUserName: Scalars['String'];
  organisationNode: Scalars['HierarchyId'];
  status: Status;
};

export type ActivityDiversionFilterInput = {
  and?: InputMaybe<Array<ActivityDiversionFilterInput>>;
  destination?: InputMaybe<DestinationFilterInput>;
  eveUserId?: InputMaybe<IntOperationFilterInput>;
  eveUserName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ActivityDiversionFilterInput>>;
  organisationNode?: InputMaybe<HierarchyIdFilterInput>;
  status?: InputMaybe<StatusOperationFilterInput>;
};

export type ActivityDiversionMappingInput = {
  available?: InputMaybe<Scalars['String']>;
  busy?: InputMaybe<Scalars['String']>;
  holiday?: InputMaybe<Scalars['String']>;
  lunch?: InputMaybe<Scalars['String']>;
  meeting?: InputMaybe<Scalars['String']>;
  outOfOffice?: InputMaybe<Scalars['String']>;
};

export type ActivityDiversionSortInput = {
  status?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type ActivityDiversionsCollectionSegment = {
  __typename?: 'ActivityDiversionsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<ActivityDiversion>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type Agent = {
  __typename?: 'Agent';
  activity: Scalars['String'];
  eveUserName: Scalars['String'];
  firstName: Scalars['String'];
  isAvailable: Scalars['Boolean'];
  isLoggedIn: Scalars['Boolean'];
  lastName: Scalars['String'];
  skillLevel: Scalars['Int'];
};

export type AnsweredMeetingRequestEvent = MeetingEvent & {
  __typename?: 'AnsweredMeetingRequestEvent';
  dateTimeOffset: Scalars['DateTime'];
  eveUserId: Scalars['Int'];
  meetingId: Scalars['String'];
  meetingTitle: Scalars['String'];
};

export enum ApplyPolicy {
  AfterResolver = 'AFTER_RESOLVER',
  BeforeResolver = 'BEFORE_RESOLVER',
  Validation = 'VALIDATION'
}

export type AreaNumbersFilterInput = {
  area: Scalars['String'];
  showGoldNumbers: Scalars['Boolean'];
  showStandardNumbers: Scalars['Boolean'];
};

export enum AuthenticationOptionsType {
  IpAddress = 'IP_ADDRESS',
  Username = 'USERNAME'
}

export type AuthenticationOptionsTypeOperationFilterInput = {
  eq?: InputMaybe<AuthenticationOptionsType>;
  in?: InputMaybe<Array<AuthenticationOptionsType>>;
  neq?: InputMaybe<AuthenticationOptionsType>;
  nin?: InputMaybe<Array<AuthenticationOptionsType>>;
};

export type AvailableDdiModel = {
  __typename?: 'AvailableDDIModel';
  levelCode: Scalars['String'];
  number: Scalars['String'];
  supplierCode: Scalars['String'];
};

export type AvailableDdiModelInput = {
  levelCode: Scalars['String'];
  number: Scalars['String'];
  supplierCode: Scalars['String'];
};

export type BankHoliday = {
  __typename?: 'BankHoliday';
  bankHolidayId: Scalars['Int'];
  createDate: Scalars['DateTime'];
  date: Scalars['DateTime'];
  notes: Scalars['String'];
  regionId: Scalars['Int'];
  title: Scalars['String'];
};

export type BankHolidayFilterInput = {
  and?: InputMaybe<Array<BankHolidayFilterInput>>;
  bankHolidayId?: InputMaybe<IntOperationFilterInput>;
  createDate?: InputMaybe<DateTimeOperationFilterInput>;
  date?: InputMaybe<DateTimeOperationFilterInput>;
  notes?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<BankHolidayFilterInput>>;
  regionId?: InputMaybe<IntOperationFilterInput>;
  title?: InputMaybe<StringOperationFilterInput>;
};

export type BankHolidayInput = {
  bankHolidayId: Scalars['Int'];
};

export type BankHolidaySortInput = {
  bankHolidayId?: InputMaybe<SortEnumType>;
  createDate?: InputMaybe<SortEnumType>;
  date?: InputMaybe<SortEnumType>;
  notes?: InputMaybe<SortEnumType>;
  regionId?: InputMaybe<SortEnumType>;
  title?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type BankHolidaysConnection = {
  __typename?: 'BankHolidaysConnection';
  /** A list of edges. */
  edges?: Maybe<Array<BankHolidaysEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<BankHoliday>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type BankHolidaysEdge = {
  __typename?: 'BankHolidaysEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: BankHoliday;
};

export type BooleanOperationFilterInput = {
  eq?: InputMaybe<Scalars['Boolean']>;
  neq?: InputMaybe<Scalars['Boolean']>;
};

export type ByteOperationFilterInput = {
  eq?: InputMaybe<Scalars['Byte']>;
  gt?: InputMaybe<Scalars['Byte']>;
  gte?: InputMaybe<Scalars['Byte']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Byte']>>>;
  lt?: InputMaybe<Scalars['Byte']>;
  lte?: InputMaybe<Scalars['Byte']>;
  neq?: InputMaybe<Scalars['Byte']>;
  ngt?: InputMaybe<Scalars['Byte']>;
  ngte?: InputMaybe<Scalars['Byte']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Byte']>>>;
  nlt?: InputMaybe<Scalars['Byte']>;
  nlte?: InputMaybe<Scalars['Byte']>;
};

export type CallQueue = {
  __typename?: 'CallQueue';
  _24hrStatisticsFixed: Scalars['Boolean'];
  _24hrStatisticsResetTime: Scalars['TimeSpan'];
  agentTimeOut: Scalars['Int'];
  alternateQueueInfo: Scalars['Boolean'];
  avatarImageId?: Maybe<Scalars['Int']>;
  callQueueId: Scalars['Int'];
  callRecording: CallRecording;
  callbackAttempts: Scalars['Int'];
  callbackMessagePrompt?: Maybe<Prompt>;
  callbackRequeue: Scalars['Int'];
  callbackValidity: Scalars['Int'];
  checkAvailablePresence: Scalars['Boolean'];
  description: Scalars['String'];
  distributionType: DistributionType;
  excludeMobile: Scalars['Boolean'];
  forwardCallsAfter: Scalars['Int'];
  forwardCallsTo?: Maybe<Destination>;
  guid: Scalars['UUID'];
  helpNumber?: Maybe<Destination>;
  ignoreInitialDiversion: Scalars['Boolean'];
  isLight: Scalars['Boolean'];
  maxAgentAttempts: Scalars['Int'];
  maxAgentAttemptsFallback?: Maybe<Destination>;
  maxCallsInQueue: Scalars['Int'];
  maxWaitTime: Scalars['Int'];
  missedCallsLogout: Scalars['Int'];
  name: Scalars['String'];
  number: Number;
  organisationNode?: Maybe<Scalars['HierarchyId']>;
  placedInQueueMessagePrompt?: Maybe<Prompt>;
  playEstimatedTime: Scalars['Boolean'];
  playQueuePosition: Scalars['Boolean'];
  playRingCallingAgent: Scalars['Boolean'];
  preferredNumberType: Scalars['String'];
  progressMessagePrompt?: Maybe<Prompt>;
  progressRepeat: Scalars['Byte'];
  queueFullForwardTo?: Maybe<Destination>;
  queueFullSendToBusy: Scalars['Boolean'];
  queueSize: Scalars['Int'];
  queueingMessagePrompt?: Maybe<Prompt>;
  ringingAgents: Scalars['Int'];
  schedules: Array<Schedule>;
  showInSearch: Scalars['Boolean'];
  statisticsPeriod: Scalars['Byte'];
  supervisors: Array<EveUser>;
  useLongestWait: Scalars['Boolean'];
  users: Array<CallQueueUser>;
  wrapUpTime: Scalars['Int'];
};

export type CallQueueFilterInput = {
  _24hrStatisticsFixed?: InputMaybe<BooleanOperationFilterInput>;
  _24hrStatisticsResetTime?: InputMaybe<TimeSpanOperationFilterInput>;
  agentTimeOut?: InputMaybe<IntOperationFilterInput>;
  alternateQueueInfo?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<CallQueueFilterInput>>;
  avatarImageId?: InputMaybe<IntOperationFilterInput>;
  callQueueId?: InputMaybe<IntOperationFilterInput>;
  callRecording?: InputMaybe<CallRecordingOperationFilterInput>;
  callbackAttempts?: InputMaybe<IntOperationFilterInput>;
  callbackMessagePrompt?: InputMaybe<PromptFilterInput>;
  callbackRequeue?: InputMaybe<IntOperationFilterInput>;
  callbackValidity?: InputMaybe<IntOperationFilterInput>;
  checkAvailablePresence?: InputMaybe<BooleanOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  distributionType?: InputMaybe<DistributionTypeOperationFilterInput>;
  excludeMobile?: InputMaybe<BooleanOperationFilterInput>;
  forwardCallsAfter?: InputMaybe<IntOperationFilterInput>;
  forwardCallsTo?: InputMaybe<DestinationFilterInput>;
  guid?: InputMaybe<UuidOperationFilterInput>;
  helpNumber?: InputMaybe<DestinationFilterInput>;
  ignoreInitialDiversion?: InputMaybe<BooleanOperationFilterInput>;
  isLight?: InputMaybe<BooleanOperationFilterInput>;
  maxAgentAttempts?: InputMaybe<IntOperationFilterInput>;
  maxAgentAttemptsFallback?: InputMaybe<DestinationFilterInput>;
  maxCallsInQueue?: InputMaybe<IntOperationFilterInput>;
  maxWaitTime?: InputMaybe<IntOperationFilterInput>;
  missedCallsLogout?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  number?: InputMaybe<NumberFilterInput>;
  or?: InputMaybe<Array<CallQueueFilterInput>>;
  organisationNode?: InputMaybe<HierarchyIdFilterInput>;
  placedInQueueMessagePrompt?: InputMaybe<PromptFilterInput>;
  playEstimatedTime?: InputMaybe<BooleanOperationFilterInput>;
  playQueuePosition?: InputMaybe<BooleanOperationFilterInput>;
  playRingCallingAgent?: InputMaybe<BooleanOperationFilterInput>;
  preferredNumberType?: InputMaybe<StringOperationFilterInput>;
  progressMessagePrompt?: InputMaybe<PromptFilterInput>;
  progressRepeat?: InputMaybe<ByteOperationFilterInput>;
  queueFullForwardTo?: InputMaybe<DestinationFilterInput>;
  queueFullSendToBusy?: InputMaybe<BooleanOperationFilterInput>;
  queueSize?: InputMaybe<IntOperationFilterInput>;
  queueingMessagePrompt?: InputMaybe<PromptFilterInput>;
  ringingAgents?: InputMaybe<IntOperationFilterInput>;
  schedules?: InputMaybe<ListFilterInputTypeOfScheduleFilterInput>;
  showInSearch?: InputMaybe<BooleanOperationFilterInput>;
  statisticsPeriod?: InputMaybe<ByteOperationFilterInput>;
  supervisors?: InputMaybe<ListFilterInputTypeOfEveUserFilterInput>;
  useLongestWait?: InputMaybe<BooleanOperationFilterInput>;
  users?: InputMaybe<ListFilterInputTypeOfCallQueueUserFilterInput>;
  wrapUpTime?: InputMaybe<IntOperationFilterInput>;
};

export type CallQueueInput = {
  _24hrStatisticsFixed?: InputMaybe<Scalars['Boolean']>;
  _24hrStatisticsResetTime?: InputMaybe<Scalars['TimeSpan']>;
  addCallQueueSchedules?: InputMaybe<Array<ScheduleInput>>;
  addCallQueueUsers?: InputMaybe<Array<CallQueueUserInput>>;
  addSupervisors?: InputMaybe<Array<EveUserSelectionInput>>;
  agentTimeOut?: InputMaybe<Scalars['Int']>;
  alternateQueueInfo?: InputMaybe<Scalars['Boolean']>;
  avatarImageId?: InputMaybe<Scalars['Int']>;
  callQueueId?: InputMaybe<Scalars['Int']>;
  callRecording?: InputMaybe<CallRecording>;
  callbackAttempts?: InputMaybe<Scalars['Int']>;
  callbackMessagePrompt?: InputMaybe<PromptSelectionInput>;
  callbackRequeue?: InputMaybe<Scalars['Int']>;
  callbackValidity?: InputMaybe<Scalars['Int']>;
  checkAvailablePresence?: InputMaybe<Scalars['Boolean']>;
  deleteCallQueueSchedules?: InputMaybe<Array<ScheduleInput>>;
  deleteCallQueueUsers?: InputMaybe<Array<CallQueueUserInput>>;
  deleteSupervisors?: InputMaybe<Array<EveUserSelectionInput>>;
  description?: InputMaybe<Scalars['String']>;
  distributionType?: InputMaybe<DistributionType>;
  excludeMobile?: InputMaybe<Scalars['Boolean']>;
  forwardCallsAfter?: InputMaybe<Scalars['Int']>;
  forwardCallsTo?: InputMaybe<DestinationInput>;
  helpNumber?: InputMaybe<DestinationInput>;
  ignoreInitialDiversion?: InputMaybe<Scalars['Boolean']>;
  maxAgentAttempts?: InputMaybe<Scalars['Int']>;
  maxAgentAttemptsFallback?: InputMaybe<DestinationInput>;
  maxCallsInQueue?: InputMaybe<Scalars['Int']>;
  maxWaitTime?: InputMaybe<Scalars['Int']>;
  missedCallsLogout?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<NumberInput>;
  organisationNode?: InputMaybe<Scalars['HierarchyId']>;
  placedInQueueMessagePrompt?: InputMaybe<PromptSelectionInput>;
  playEstimatedTime?: InputMaybe<Scalars['Boolean']>;
  playQueuePosition?: InputMaybe<Scalars['Boolean']>;
  playRingCallingAgent?: InputMaybe<Scalars['Boolean']>;
  preferredNumberType?: InputMaybe<Scalars['String']>;
  progressMessagePrompt?: InputMaybe<PromptSelectionInput>;
  progressRepeat?: InputMaybe<Scalars['Int']>;
  queueFullForwardTo?: InputMaybe<DestinationInput>;
  queueFullSendToBusy?: InputMaybe<Scalars['Boolean']>;
  queueSize?: InputMaybe<Scalars['Int']>;
  queueingMessagePrompt?: InputMaybe<PromptSelectionInput>;
  ringingAgents?: InputMaybe<Scalars['Int']>;
  showInSearch?: InputMaybe<Scalars['Boolean']>;
  statisticsPeriod?: InputMaybe<Scalars['Byte']>;
  updateCallQueueSchedules?: InputMaybe<Array<ScheduleInput>>;
  updateCallQueueUsers?: InputMaybe<Array<CallQueueUserInput>>;
  useLongestWait?: InputMaybe<Scalars['Boolean']>;
  wrapUpTime?: InputMaybe<Scalars['Int']>;
};

export type CallQueueLogin = {
  __typename?: 'CallQueueLogin';
  callQueueId: Scalars['Int'];
  eveUserId: Scalars['Int'];
  isLoggedIn: Scalars['Boolean'];
  name: Scalars['String'];
};

export type CallQueueLoginFilterInput = {
  and?: InputMaybe<Array<CallQueueLoginFilterInput>>;
  callQueueId?: InputMaybe<IntOperationFilterInput>;
  eveUserId?: InputMaybe<IntOperationFilterInput>;
  isLoggedIn?: InputMaybe<BooleanOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CallQueueLoginFilterInput>>;
};

export type CallQueueLoginInput = {
  callQueueId: Scalars['Int'];
  eveUserId: Scalars['Int'];
  isloggedIn: Scalars['Boolean'];
};

export type CallQueueLoginSortInput = {
  callQueueId?: InputMaybe<SortEnumType>;
  eveUserId?: InputMaybe<SortEnumType>;
  isLoggedIn?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

export type CallQueueSortInput = {
  name?: InputMaybe<SortEnumType>;
};

export type CallQueueUser = {
  __typename?: 'CallQueueUser';
  eveUser: EveUser;
  eveUserId: Scalars['Int'];
  groupId: Scalars['Int'];
  priority: Scalars['Int'];
  skillRating: Scalars['Int'];
};

export type CallQueueUserFilterInput = {
  and?: InputMaybe<Array<CallQueueUserFilterInput>>;
  eveUser?: InputMaybe<EveUserFilterInput>;
  eveUserId?: InputMaybe<IntOperationFilterInput>;
  groupId?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<CallQueueUserFilterInput>>;
  priority?: InputMaybe<IntOperationFilterInput>;
  skillRating?: InputMaybe<IntOperationFilterInput>;
};

export type CallQueueUserInput = {
  eveUser: EveUserSelectionInput;
  priority?: InputMaybe<Scalars['Int']>;
  skillRating?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of items. */
export type CallQueuesConnection = {
  __typename?: 'CallQueuesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CallQueuesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<CallQueue>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type CallQueuesEdge = {
  __typename?: 'CallQueuesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: CallQueue;
};

export enum CallRecording {
  Days30 = 'DAYS30',
  Months6 = 'MONTHS6',
  Months12 = 'MONTHS12',
  None = 'NONE',
  Years7 = 'YEARS7'
}

export type CallRecordingOperationFilterInput = {
  eq?: InputMaybe<CallRecording>;
  in?: InputMaybe<Array<CallRecording>>;
  neq?: InputMaybe<CallRecording>;
  nin?: InputMaybe<Array<CallRecording>>;
};

export type Calldto = {
  __typename?: 'Calldto';
  duration: Scalars['Int'];
  isSeen: Scalars['Boolean'];
  itemId: Scalars['Int'];
  itemType: Scalars['String'];
  remoteParty: Remoteparty;
  startTime: Scalars['DateTime'];
};

export type CancelJoinDiagnosticsRequest = IJoinDiagnosticsRequest & {
  __typename?: 'CancelJoinDiagnosticsRequest';
  sessionId: Scalars['String'];
};

export type CancelJoinMeetingRequest = MeetingRequest & {
  __typename?: 'CancelJoinMeetingRequest';
  meetingId: Scalars['String'];
  mwt: Scalars['String'];
  requestor: EveUser;
};

export type CancelJoinMeetingRequestEvent = MeetingEvent & {
  __typename?: 'CancelJoinMeetingRequestEvent';
  dateTimeOffset: Scalars['DateTime'];
  eveUserName: Scalars['String'];
  meetingId: Scalars['String'];
  meetingTitle: Scalars['String'];
};

export type ClaimRefreshTokenInput = {
  deviceName: Scalars['String'];
  qrCode: Scalars['String'];
};

/** Information about the offset pagination. */
export type CollectionSegmentInfo = {
  __typename?: 'CollectionSegmentInfo';
  /** Indicates whether more items exist following the set defined by the clients arguments. */
  hasNextPage: Scalars['Boolean'];
  /** Indicates whether more items exist prior the set defined by the clients arguments. */
  hasPreviousPage: Scalars['Boolean'];
};

export type CommunicationLog = {
  __typename?: 'CommunicationLog';
  flushCache: Scalars['Boolean'];
  generatedAt: Scalars['DateTime'];
  hintCount: Scalars['Int'];
  historyItems: Array<Historyitem>;
};

/** A segment of a collection. */
export type CompaniesCollectionSegment = {
  __typename?: 'CompaniesCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Company>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type Company = {
  __typename?: 'Company';
  extensionDailing: Scalars['Int'];
  externalRef: Scalars['String'];
  organisation: Organisation;
};

export type CompanyFilterInput = {
  and?: InputMaybe<Array<CompanyFilterInput>>;
  extensionDailing?: InputMaybe<IntOperationFilterInput>;
  externalRef?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CompanyFilterInput>>;
  organisation?: InputMaybe<OrganisationFilterInput>;
};

export type CompanySortInput = {
  externalRef?: InputMaybe<SortEnumType>;
};

export type Contact = {
  __typename?: 'Contact';
  avatarImageId?: Maybe<Scalars['Int']>;
  contactId: Scalars['Int'];
  email?: Maybe<Scalars['String']>;
  eveUserId?: Maybe<Scalars['Int']>;
  eveUserName?: Maybe<Scalars['String']>;
  excludeFromIntrusion?: Maybe<Scalars['Boolean']>;
  favourite: Scalars['Boolean'];
  firstName: Scalars['String'];
  fullName: Scalars['String'];
  internalNumber?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  organisationNode?: Maybe<Scalars['HierarchyId']>;
  parentEveUserId?: Maybe<Scalars['Int']>;
  phoneNumber?: Maybe<Scalars['String']>;
  surname: Scalars['String'];
};

export type ContactFilterInput = {
  and?: InputMaybe<Array<ContactFilterInput>>;
  avatarImageId?: InputMaybe<IntOperationFilterInput>;
  contactId?: InputMaybe<IntOperationFilterInput>;
  email?: InputMaybe<StringOperationFilterInput>;
  eveUserId?: InputMaybe<IntOperationFilterInput>;
  eveUserName?: InputMaybe<StringOperationFilterInput>;
  excludeFromIntrusion?: InputMaybe<BooleanOperationFilterInput>;
  favourite?: InputMaybe<BooleanOperationFilterInput>;
  firstName?: InputMaybe<StringOperationFilterInput>;
  fullName?: InputMaybe<StringOperationFilterInput>;
  internalNumber?: InputMaybe<StringOperationFilterInput>;
  number?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ContactFilterInput>>;
  organisationNode?: InputMaybe<HierarchyIdFilterInput>;
  parentEveUserId?: InputMaybe<IntOperationFilterInput>;
  phoneNumber?: InputMaybe<StringOperationFilterInput>;
  surname?: InputMaybe<StringOperationFilterInput>;
};

export type ContactInput = {
  contactId?: InputMaybe<Scalars['Int']>;
  email?: InputMaybe<Scalars['String']>;
  favourite?: InputMaybe<Scalars['Boolean']>;
  firstName?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  surname?: InputMaybe<Scalars['String']>;
};

export type ContactSortInput = {
  contactId?: InputMaybe<SortEnumType>;
  firstName?: InputMaybe<SortEnumType>;
  surname?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type ContactsCollectionSegment = {
  __typename?: 'ContactsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Contact>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type CreateOrderNumbersInput = {
  area: Scalars['String'];
  orderNumbers: Array<AvailableDdiModelInput>;
  organisationId: Scalars['Int'];
};

export type CurrentAgentPresence = {
  __typename?: 'CurrentAgentPresence';
  count: Scalars['Int'];
  name: Scalars['String'];
};

/** A segment of a collection. */
export type CurrentEveUserCustomPresentationGroupsCollectionSegment = {
  __typename?: 'CurrentEveUserCustomPresentationGroupsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<CustomPresentationGroup>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type CustomPresentationGroup = {
  __typename?: 'CustomPresentationGroup';
  customPresentationGroupId: Scalars['Int'];
  name: Scalars['String'];
  organisationNode?: Maybe<Scalars['HierarchyId']>;
  presentationNumber: Scalars['String'];
};

export type CustomPresentationGroupFilterInput = {
  and?: InputMaybe<Array<CustomPresentationGroupFilterInput>>;
  customPresentationGroupId?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CustomPresentationGroupFilterInput>>;
  organisationNode?: InputMaybe<HierarchyIdFilterInput>;
  presentationNumber?: InputMaybe<StringOperationFilterInput>;
};

export type CustomPresentationGroupSortInput = {
  name?: InputMaybe<SortEnumType>;
  presentationNumber?: InputMaybe<SortEnumType>;
};

export type DateTimeOperationFilterInput = {
  eq?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  neq?: InputMaybe<Scalars['DateTime']>;
  ngt?: InputMaybe<Scalars['DateTime']>;
  ngte?: InputMaybe<Scalars['DateTime']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  nlt?: InputMaybe<Scalars['DateTime']>;
  nlte?: InputMaybe<Scalars['DateTime']>;
};

export type Destination = {
  __typename?: 'Destination';
  destinationId: Scalars['Int'];
  destinationType: DestinationType;
  name: Scalars['String'];
  organisationNode?: Maybe<Scalars['HierarchyId']>;
};

export type DestinationFilterInput = {
  and?: InputMaybe<Array<DestinationFilterInput>>;
  destinationId?: InputMaybe<IntOperationFilterInput>;
  destinationType?: InputMaybe<DestinationTypeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<DestinationFilterInput>>;
  organisationNode?: InputMaybe<HierarchyIdFilterInput>;
};

export type DestinationInput = {
  destinationId?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

export type DestinationSortInput = {
  name?: InputMaybe<SortEnumType>;
};

export enum DestinationType {
  CallQueue = 'CALL_QUEUE',
  Contact = 'CONTACT',
  EveUser = 'EVE_USER',
  GroupVoicemail = 'GROUP_VOICEMAIL',
  HuntGroup = 'HUNT_GROUP',
  Ivr = 'IVR',
  Static = 'STATIC'
}

export type DestinationTypeOperationFilterInput = {
  eq?: InputMaybe<DestinationType>;
  in?: InputMaybe<Array<DestinationType>>;
  neq?: InputMaybe<DestinationType>;
  nin?: InputMaybe<Array<DestinationType>>;
};

/** A segment of a collection. */
export type DestinationsCollectionSegment = {
  __typename?: 'DestinationsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Destination>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type DiagnosticsSessionExceptionResponse = IDiagnosticsSessionResponse & {
  __typename?: 'DiagnosticsSessionExceptionResponse';
  data: Scalars['String'];
  errorMessage: Scalars['String'];
  requestId: Scalars['String'];
  status: HttpStatusCode;
};

export type DiagnosticsSessionExceptionResponseInput = {
  data: Scalars['String'];
  errorMessage: Scalars['String'];
  requestId: Scalars['String'];
  status: HttpStatusCode;
};

export enum DistributionType {
  Priority = 'PRIORITY',
  Skills = 'SKILLS'
}

export type DistributionTypeOperationFilterInput = {
  eq?: InputMaybe<DistributionType>;
  in?: InputMaybe<Array<DistributionType>>;
  neq?: InputMaybe<DistributionType>;
  nin?: InputMaybe<Array<DistributionType>>;
};

export type EveUser = {
  __typename?: 'EveUser';
  adminLevel: UserLevel;
  adminOrganisationId?: Maybe<Scalars['Int']>;
  avatarImageId?: Maybe<Scalars['Int']>;
  callIntrusion: Scalars['Boolean'];
  devicePassword?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  endUserSiteNode?: Maybe<Scalars['HierarchyId']>;
  eveUserId: Scalars['Int'];
  eveUserName: Scalars['String'];
  firstName: Scalars['String'];
  fullName: Scalars['String'];
  internalNumber?: Maybe<Number>;
  licenseType: LicenseType;
  number?: Maybe<Number>;
  presentation?: Maybe<EveUserPresentation>;
  status?: Maybe<Status>;
  surname: Scalars['String'];
};

export type EveUserExternalCalendarInput = {
  data: Scalars['String'];
  externalCalendarType: ExternalCalendarType;
  name: Scalars['String'];
};

export type EveUserFilterInput = {
  adminLevel?: InputMaybe<UserLevelOperationFilterInput>;
  adminOrganisationId?: InputMaybe<IntOperationFilterInput>;
  and?: InputMaybe<Array<EveUserFilterInput>>;
  avatarImageId?: InputMaybe<IntOperationFilterInput>;
  callIntrusion?: InputMaybe<BooleanOperationFilterInput>;
  devicePassword?: InputMaybe<StringOperationFilterInput>;
  email?: InputMaybe<StringOperationFilterInput>;
  endUserSiteNode?: InputMaybe<HierarchyIdFilterInput>;
  eveUserId?: InputMaybe<IntOperationFilterInput>;
  eveUserName?: InputMaybe<StringOperationFilterInput>;
  firstName?: InputMaybe<StringOperationFilterInput>;
  fullName?: InputMaybe<StringOperationFilterInput>;
  internalNumber?: InputMaybe<NumberFilterInput>;
  licenseType?: InputMaybe<LicenseTypeOperationFilterInput>;
  number?: InputMaybe<NumberFilterInput>;
  or?: InputMaybe<Array<EveUserFilterInput>>;
  presentation?: InputMaybe<EveUserPresentationFilterInput>;
  status?: InputMaybe<NullableOfStatusOperationFilterInput>;
  surname?: InputMaybe<StringOperationFilterInput>;
};

export type EveUserInput = {
  eveUserId: Scalars['Int'];
  presentationId?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Status>;
};

export type EveUserPresentation = {
  __typename?: 'EveUserPresentation';
  name: Scalars['String'];
  presentationId: Scalars['Int'];
  presentationNumber: Scalars['String'];
};

export type EveUserPresentationFilterInput = {
  and?: InputMaybe<Array<EveUserPresentationFilterInput>>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<EveUserPresentationFilterInput>>;
  presentationId?: InputMaybe<IntOperationFilterInput>;
  presentationNumber?: InputMaybe<StringOperationFilterInput>;
};

export type EveUserSelectionInput = {
  eveUserId: Scalars['Int'];
};

export type EveUserSortInput = {
  eveUserName?: InputMaybe<SortEnumType>;
  firstName?: InputMaybe<SortEnumType>;
  surname?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type EveUsersCollectionSegment = {
  __typename?: 'EveUsersCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<EveUser>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type ExternalCalendar = {
  __typename?: 'ExternalCalendar';
  eveUserExternalCalendarId: Scalars['Int'];
  externalCalendarType: ExternalCalendarType;
  name: Scalars['String'];
};

export type ExternalCalendarEvent = {
  __typename?: 'ExternalCalendarEvent';
  endTime: Scalars['DateTime'];
  host: Scalars['String'];
  particpants: Scalars['Int'];
  startTime: Scalars['DateTime'];
  title: Scalars['String'];
};

export enum ExternalCalendarType {
  Outlook = 'OUTLOOK'
}

export type FirebaseInput = {
  firebaseToken: Scalars['String'];
  firebaseTokenType: FirebaseTokenType;
};

export enum FirebaseTokenType {
  Android = 'ANDROID',
  Ios = 'IOS'
}

export type Group = {
  __typename?: 'Group';
  agents: Array<Agent>;
  domain: Scalars['String'];
  id: Scalars['Int'];
  isAllowUsingFunctionNumber: Scalars['Boolean'];
  isLoggedIn: Scalars['Boolean'];
  isNightMode: Scalars['Boolean'];
  name: Scalars['String'];
  roles: Array<Role>;
  statistic: Statistic;
  type: Scalars['String'];
};

export type GroupInboxVoicemaildto = {
  __typename?: 'GroupInboxVoicemaildto';
  callItemId: Scalars['Int'];
  click2CallUrl: Scalars['String'];
  inboxName: Scalars['String'];
  isPlayed: Scalars['Boolean'];
  isSeen: Scalars['Boolean'];
  itemId: Scalars['Int'];
  itemType: Scalars['String'];
  remoteParty: Remoteparty;
  startTime: Scalars['DateTime'];
  url: Scalars['String'];
};

export type HierarchyIdFilterInput = {
  and?: InputMaybe<Array<HierarchyIdFilterInput>>;
  eq?: InputMaybe<Scalars['HierarchyId']>;
  isDescendantOf?: InputMaybe<Scalars['HierarchyId']>;
  isParentOf?: InputMaybe<Scalars['HierarchyId']>;
  neq?: InputMaybe<Scalars['HierarchyId']>;
  or?: InputMaybe<Array<HierarchyIdFilterInput>>;
};

export type Historyitem = {
  __typename?: 'Historyitem';
  callDTO?: Maybe<Calldto>;
  groupInboxVoicemaildto?: Maybe<GroupInboxVoicemaildto>;
  voiceMailDTO?: Maybe<Voicemaildto>;
};

export enum HttpStatusCode {
  Accepted = 'ACCEPTED',
  AlreadyReported = 'ALREADY_REPORTED',
  BadGateway = 'BAD_GATEWAY',
  BadRequest = 'BAD_REQUEST',
  Conflict = 'CONFLICT',
  Continue = 'CONTINUE',
  Created = 'CREATED',
  EarlyHints = 'EARLY_HINTS',
  ExpectationFailed = 'EXPECTATION_FAILED',
  FailedDependency = 'FAILED_DEPENDENCY',
  Forbidden = 'FORBIDDEN',
  Found = 'FOUND',
  GatewayTimeout = 'GATEWAY_TIMEOUT',
  Gone = 'GONE',
  HttpVersionNotSupported = 'HTTP_VERSION_NOT_SUPPORTED',
  ImUsed = 'IM_USED',
  InsufficientStorage = 'INSUFFICIENT_STORAGE',
  InternalServerError = 'INTERNAL_SERVER_ERROR',
  LengthRequired = 'LENGTH_REQUIRED',
  Locked = 'LOCKED',
  LoopDetected = 'LOOP_DETECTED',
  MethodNotAllowed = 'METHOD_NOT_ALLOWED',
  MisdirectedRequest = 'MISDIRECTED_REQUEST',
  MovedPermanently = 'MOVED_PERMANENTLY',
  MultipleChoices = 'MULTIPLE_CHOICES',
  MultiStatus = 'MULTI_STATUS',
  NetworkAuthenticationRequired = 'NETWORK_AUTHENTICATION_REQUIRED',
  NonAuthoritativeInformation = 'NON_AUTHORITATIVE_INFORMATION',
  NotAcceptable = 'NOT_ACCEPTABLE',
  NotExtended = 'NOT_EXTENDED',
  NotFound = 'NOT_FOUND',
  NotImplemented = 'NOT_IMPLEMENTED',
  NotModified = 'NOT_MODIFIED',
  NoContent = 'NO_CONTENT',
  Ok = 'OK',
  PartialContent = 'PARTIAL_CONTENT',
  PaymentRequired = 'PAYMENT_REQUIRED',
  PermanentRedirect = 'PERMANENT_REDIRECT',
  PreconditionFailed = 'PRECONDITION_FAILED',
  PreconditionRequired = 'PRECONDITION_REQUIRED',
  Processing = 'PROCESSING',
  ProxyAuthenticationRequired = 'PROXY_AUTHENTICATION_REQUIRED',
  RedirectKeepVerb = 'REDIRECT_KEEP_VERB',
  RequestedRangeNotSatisfiable = 'REQUESTED_RANGE_NOT_SATISFIABLE',
  RequestEntityTooLarge = 'REQUEST_ENTITY_TOO_LARGE',
  RequestHeaderFieldsTooLarge = 'REQUEST_HEADER_FIELDS_TOO_LARGE',
  RequestTimeout = 'REQUEST_TIMEOUT',
  RequestUriTooLong = 'REQUEST_URI_TOO_LONG',
  ResetContent = 'RESET_CONTENT',
  SeeOther = 'SEE_OTHER',
  ServiceUnavailable = 'SERVICE_UNAVAILABLE',
  SwitchingProtocols = 'SWITCHING_PROTOCOLS',
  TooManyRequests = 'TOO_MANY_REQUESTS',
  Unauthorized = 'UNAUTHORIZED',
  UnavailableForLegalReasons = 'UNAVAILABLE_FOR_LEGAL_REASONS',
  UnprocessableEntity = 'UNPROCESSABLE_ENTITY',
  UnsupportedMediaType = 'UNSUPPORTED_MEDIA_TYPE',
  Unused = 'UNUSED',
  UpgradeRequired = 'UPGRADE_REQUIRED',
  UseProxy = 'USE_PROXY',
  VariantAlsoNegotiates = 'VARIANT_ALSO_NEGOTIATES'
}

export type IDiagnosticsSessionRequest = {
  requestId: Scalars['String'];
};

export type IDiagnosticsSessionResponse = {
  requestId: Scalars['String'];
  status: HttpStatusCode;
};

export type IJoinDiagnosticsRequest = {
  sessionId: Scalars['String'];
};

export type IMeetingUser = {
  meetingUserType: Scalars['String'];
};

export type IMeetingUserFilterInput = {
  and?: InputMaybe<Array<IMeetingUserFilterInput>>;
  meetingUserType?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<IMeetingUserFilterInput>>;
};

export enum IpStatus {
  BadDestination = 'BAD_DESTINATION',
  BadHeader = 'BAD_HEADER',
  BadOption = 'BAD_OPTION',
  BadRoute = 'BAD_ROUTE',
  DestinationHostUnreachable = 'DESTINATION_HOST_UNREACHABLE',
  DestinationNetworkUnreachable = 'DESTINATION_NETWORK_UNREACHABLE',
  DestinationPortUnreachable = 'DESTINATION_PORT_UNREACHABLE',
  DestinationProtocolUnreachable = 'DESTINATION_PROTOCOL_UNREACHABLE',
  DestinationScopeMismatch = 'DESTINATION_SCOPE_MISMATCH',
  DestinationUnreachable = 'DESTINATION_UNREACHABLE',
  HardwareError = 'HARDWARE_ERROR',
  IcmpError = 'ICMP_ERROR',
  NoResources = 'NO_RESOURCES',
  PacketTooBig = 'PACKET_TOO_BIG',
  ParameterProblem = 'PARAMETER_PROBLEM',
  SourceQuench = 'SOURCE_QUENCH',
  Success = 'SUCCESS',
  TimedOut = 'TIMED_OUT',
  TimeExceeded = 'TIME_EXCEEDED',
  TtlExpired = 'TTL_EXPIRED',
  TtlReassemblyTimeExceeded = 'TTL_REASSEMBLY_TIME_EXCEEDED',
  Unknown = 'UNKNOWN',
  UnrecognizedNextHeader = 'UNRECOGNIZED_NEXT_HEADER'
}

export type IntOperationFilterInput = {
  eq?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  neq?: InputMaybe<Scalars['Int']>;
  ngt?: InputMaybe<Scalars['Int']>;
  ngte?: InputMaybe<Scalars['Int']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  nlt?: InputMaybe<Scalars['Int']>;
  nlte?: InputMaybe<Scalars['Int']>;
};

export type InternalNumberInput = {
  createdInternalNumbers?: InputMaybe<Array<Scalars['String']>>;
  deletedInternalNumbers?: InputMaybe<Array<Scalars['String']>>;
  organisationId: Scalars['Int'];
};

export type JoinDiagnosticsRequest = IJoinDiagnosticsRequest & {
  __typename?: 'JoinDiagnosticsRequest';
  sessionId: Scalars['String'];
};

export type JoinMeetingRequest = MeetingRequest & {
  __typename?: 'JoinMeetingRequest';
  meetingId: Scalars['String'];
  mwt: Scalars['String'];
  requestor: EveUser;
};

export type JoinMeetingRequestEvent = MeetingEvent & {
  __typename?: 'JoinMeetingRequestEvent';
  dateTimeOffset: Scalars['DateTime'];
  eveUserName: Scalars['String'];
  meetingId: Scalars['String'];
  meetingTitle: Scalars['String'];
};

export type KeyValuePairOfStringAndString = {
  __typename?: 'KeyValuePairOfStringAndString';
  key: Scalars['String'];
  value: Scalars['String'];
};

export type Library = {
  __typename?: 'Library';
  data: Array<Scalars['Byte']>;
  description: Scalars['String'];
  libraryId: Scalars['Int'];
  name: Scalars['String'];
  organisationNode: Scalars['HierarchyId'];
};

export type LibraryFilterInput = {
  and?: InputMaybe<Array<LibraryFilterInput>>;
  data?: InputMaybe<ListByteOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  libraryId?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<LibraryFilterInput>>;
  organisationNode?: InputMaybe<HierarchyIdFilterInput>;
};

export enum LicenseType {
  Base = 'BASE',
  Entry = 'ENTRY',
  Essential = 'ESSENTIAL',
  EveryThing = 'EVERY_THING',
  EveryWhere = 'EVERY_WHERE',
  None = 'NONE',
  Prime = 'PRIME',
  TeamsUser = 'TEAMS_USER'
}

export type LicenseTypeOperationFilterInput = {
  eq?: InputMaybe<LicenseType>;
  in?: InputMaybe<Array<LicenseType>>;
  neq?: InputMaybe<LicenseType>;
  nin?: InputMaybe<Array<LicenseType>>;
};

export type ListByteOperationFilterInput = {
  all?: InputMaybe<ByteOperationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ByteOperationFilterInput>;
  some?: InputMaybe<ByteOperationFilterInput>;
};

export type ListFilterInputTypeOfBankHolidayFilterInput = {
  all?: InputMaybe<BankHolidayFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<BankHolidayFilterInput>;
  some?: InputMaybe<BankHolidayFilterInput>;
};

export type ListFilterInputTypeOfCallQueueUserFilterInput = {
  all?: InputMaybe<CallQueueUserFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<CallQueueUserFilterInput>;
  some?: InputMaybe<CallQueueUserFilterInput>;
};

export type ListFilterInputTypeOfEveUserFilterInput = {
  all?: InputMaybe<EveUserFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<EveUserFilterInput>;
  some?: InputMaybe<EveUserFilterInput>;
};

export type ListFilterInputTypeOfIMeetingUserFilterInput = {
  all?: InputMaybe<IMeetingUserFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<IMeetingUserFilterInput>;
  some?: InputMaybe<IMeetingUserFilterInput>;
};

export type ListFilterInputTypeOfScheduleFilterInput = {
  all?: InputMaybe<ScheduleFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ScheduleFilterInput>;
  some?: InputMaybe<ScheduleFilterInput>;
};

export type ListFilterInputTypeOfSipTrunkNumberModelFilterInput = {
  all?: InputMaybe<SipTrunkNumberModelFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<SipTrunkNumberModelFilterInput>;
  some?: InputMaybe<SipTrunkNumberModelFilterInput>;
};

export type ListSipClientLogsRequest = IDiagnosticsSessionRequest & {
  __typename?: 'ListSipClientLogsRequest';
  requestId: Scalars['String'];
};

export type ListSipClientLogsRequestInput = {
  requestId: Scalars['String'];
};

export type ListSipClientLogsResponse = IDiagnosticsSessionResponse & {
  __typename?: 'ListSipClientLogsResponse';
  logs: Array<SipClientLog>;
  requestId: Scalars['String'];
  status: HttpStatusCode;
};

export type ListSipClientLogsResponseInput = {
  logs: Array<SipClientLogInput>;
  requestId: Scalars['String'];
  status: HttpStatusCode;
};

export type LoginResult = {
  __typename?: 'LoginResult';
  authorisation: Scalars['String'];
  chatUrl: Scalars['String'];
  distinctiveRinging: Scalars['Boolean'];
  eveUser: EveUser;
  jwt: Scalars['String'];
  meetUrl: Scalars['String'];
  salt: Scalars['String'];
  signature: Scalars['String'];
  sipPassword: Scalars['String'];
  sipPushProxy: Scalars['String'];
  sipUrl: Scalars['String'];
  sipUserName: Scalars['String'];
};

export type Meeting = {
  __typename?: 'Meeting';
  endDateTime: Scalars['DateTime'];
  eveUser: EveUser;
  meetingId: Scalars['Int'];
  notes?: Maybe<Scalars['String']>;
  startDateTime: Scalars['DateTime'];
  title: Scalars['String'];
  url?: Maybe<Scalars['String']>;
  users?: Maybe<Array<IMeetingUser>>;
  usersCount: Scalars['Int'];
};

export type MeetingEveUser = IMeetingUser & {
  __typename?: 'MeetingEveUser';
  eveUser: EveUser;
  meetingUserType: Scalars['String'];
};

export type MeetingEvent = {
  dateTimeOffset: Scalars['DateTime'];
  meetingId: Scalars['String'];
  meetingTitle: Scalars['String'];
};

export type MeetingExternalUser = IMeetingUser & {
  __typename?: 'MeetingExternalUser';
  email: Scalars['String'];
  meetingUserType: Scalars['String'];
};

export type MeetingFilterInput = {
  and?: InputMaybe<Array<MeetingFilterInput>>;
  endDateTime?: InputMaybe<DateTimeOperationFilterInput>;
  eveUser?: InputMaybe<EveUserFilterInput>;
  meetingId?: InputMaybe<IntOperationFilterInput>;
  notes?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<MeetingFilterInput>>;
  startDateTime?: InputMaybe<DateTimeOperationFilterInput>;
  title?: InputMaybe<StringOperationFilterInput>;
  url?: InputMaybe<StringOperationFilterInput>;
  users?: InputMaybe<ListFilterInputTypeOfIMeetingUserFilterInput>;
  usersCount?: InputMaybe<IntOperationFilterInput>;
};

export type MeetingInput = {
  addEveUsers?: InputMaybe<Array<EveUserSelectionInput>>;
  addExternalUsers?: InputMaybe<Array<Scalars['String']>>;
  endDateTime?: InputMaybe<Scalars['DateTime']>;
  meetingId?: InputMaybe<Scalars['Int']>;
  notes?: InputMaybe<Scalars['String']>;
  reference?: InputMaybe<Scalars['String']>;
  removeEveUsers?: InputMaybe<Array<EveUserSelectionInput>>;
  removeExternalUsers?: InputMaybe<Array<Scalars['String']>>;
  startDateTime?: InputMaybe<Scalars['DateTime']>;
  title?: InputMaybe<Scalars['String']>;
};

export type MeetingRequest = {
  meetingId: Scalars['String'];
};

export type MeetingSortInput = {
  endDateTime?: InputMaybe<SortEnumType>;
  eveUser?: InputMaybe<EveUserSortInput>;
  meetingId?: InputMaybe<SortEnumType>;
  notes?: InputMaybe<SortEnumType>;
  startDateTime?: InputMaybe<SortEnumType>;
  title?: InputMaybe<SortEnumType>;
  url?: InputMaybe<SortEnumType>;
  usersCount?: InputMaybe<SortEnumType>;
};

export type MeetingStaredEvent = MeetingEvent & {
  __typename?: 'MeetingStaredEvent';
  dateTimeOffset: Scalars['DateTime'];
  meetingId: Scalars['String'];
  meetingTitle: Scalars['String'];
  startedBy_EveUserName: Scalars['String'];
  startedBy_FirstName: Scalars['String'];
  startedBy_Surname: Scalars['String'];
};

/** A segment of a collection. */
export type MeetingsCollectionSegment = {
  __typename?: 'MeetingsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Meeting>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addEveUserExternalCalendar: Scalars['Boolean'];
  claimRefreshToken?: Maybe<Scalars['String']>;
  createCallQueue?: Maybe<CallQueue>;
  createContact: Scalars['Boolean'];
  createContactV2?: Maybe<Contact>;
  createDiagnostics: Scalars['String'];
  createMeeting?: Maybe<Scalars['String']>;
  createOrderNumbers: Scalars['Boolean'];
  createPrompt?: Maybe<Prompt>;
  createSipTrunk?: Maybe<SipTrunk>;
  deleteAppleVoipToken: Scalars['Boolean'];
  deleteCommunicationLogItem: Scalars['Boolean'];
  deleteContact: Scalars['Boolean'];
  deleteEveUserExternalCalendar: Scalars['Boolean'];
  deleteFirebaseToken: Scalars['Boolean'];
  deleteMeeting: Scalars['Int'];
  deletePrompt?: Maybe<Prompt>;
  deleteRefreshToken: Scalars['Boolean'];
  joinMeeting: Scalars['String'];
  login?: Maybe<LoginResult>;
  loginRefreshToken?: Maybe<LoginResult>;
  loginV2?: Maybe<Scalars['String']>;
  sendAnsweredMeetingRequestEvent: Scalars['Boolean'];
  sendCancelDiagnosticsRequest: Scalars['Boolean'];
  sendCancelJoinMeetingRequest: Scalars['Boolean'];
  sendDiagnosticsSessionExceptionResponse: Scalars['Boolean'];
  sendJoinDiagnosticsRequest: Scalars['Boolean'];
  sendJoinMeetingRequest: Scalars['Boolean'];
  sendListSipClientLogsRequest: Scalars['Boolean'];
  sendListSipClientLogsResponse: Scalars['Boolean'];
  sendPingRequest: Scalars['Boolean'];
  sendPingResponse: Scalars['Boolean'];
  sendRefreshToken: Scalars['Boolean'];
  sendUploadSipClientLogRequest: Scalars['Boolean'];
  sendUploadSipClientLogResponse: Scalars['Boolean'];
  throwError: Scalars['Boolean'];
  updateActivityDiversionMapping: Scalars['Boolean'];
  updateCallQueue?: Maybe<CallQueue>;
  updateCallQueueLogin: Scalars['Boolean'];
  updateCallQueueLogins: Array<CallQueueLogin>;
  updateCommunicationLogItem: Scalars['Boolean'];
  updateContact: Scalars['Boolean'];
  updateContactV2?: Maybe<Contact>;
  updateEveUser?: Maybe<EveUser>;
  updateInternalNumbers: Scalars['Boolean'];
  updateMeeting: Scalars['Int'];
  updatePrompt?: Maybe<Prompt>;
  updateSipTrunk?: Maybe<SipTrunk>;
};


export type MutationAddEveUserExternalCalendarArgs = {
  input: EveUserExternalCalendarInput;
};


export type MutationClaimRefreshTokenArgs = {
  claimRefreshTokenInput: ClaimRefreshTokenInput;
};


export type MutationCreateCallQueueArgs = {
  createCallQueueInput: CallQueueInput;
};


export type MutationCreateContactArgs = {
  contact: ContactInput;
};


export type MutationCreateContactV2Args = {
  contact: ContactInput;
};


export type MutationCreateMeetingArgs = {
  meeting?: InputMaybe<MeetingInput>;
};


export type MutationCreateOrderNumbersArgs = {
  createOrderNumbersInput: CreateOrderNumbersInput;
};


export type MutationCreatePromptArgs = {
  createPromptInput: PromptInput;
};


export type MutationCreateSipTrunkArgs = {
  createSipTrunkInput: SipTrunkInput;
};


export type MutationDeleteAppleVoipTokenArgs = {
  appleVoipToken?: InputMaybe<Scalars['String']>;
};


export type MutationDeleteCommunicationLogItemArgs = {
  itemId: Scalars['Int'];
};


export type MutationDeleteContactArgs = {
  contact: ContactInput;
};


export type MutationDeleteEveUserExternalCalendarArgs = {
  eveUserExternalCalendarId: Scalars['Int'];
};


export type MutationDeleteFirebaseTokenArgs = {
  firebaseToken?: InputMaybe<Scalars['String']>;
};


export type MutationDeleteMeetingArgs = {
  meeting?: InputMaybe<MeetingInput>;
};


export type MutationDeletePromptArgs = {
  deletePromptInput: PromptInput;
};


export type MutationDeleteRefreshTokenArgs = {
  refreshToken: Scalars['String'];
};


export type MutationJoinMeetingArgs = {
  meeting: MeetingInput;
};


export type MutationLoginArgs = {
  firebaseToken?: InputMaybe<Scalars['String']>;
  password: Scalars['String'];
  user: Scalars['String'];
};


export type MutationLoginRefreshTokenArgs = {
  appleVoipToken?: InputMaybe<Scalars['String']>;
  firebaseInput?: InputMaybe<FirebaseInput>;
  firebaseToken?: InputMaybe<Scalars['String']>;
  refreshToken: Scalars['String'];
};


export type MutationLoginV2Args = {
  deviceName: Scalars['String'];
  password: Scalars['String'];
  user: Scalars['String'];
};


export type MutationSendAnsweredMeetingRequestEventArgs = {
  mwt: Scalars['String'];
};


export type MutationSendCancelDiagnosticsRequestArgs = {
  eveUserId: Scalars['Int'];
  sessionId: Scalars['String'];
};


export type MutationSendCancelJoinMeetingRequestArgs = {
  eveUserName: Scalars['String'];
  mwt: Scalars['String'];
};


export type MutationSendDiagnosticsSessionExceptionResponseArgs = {
  response: DiagnosticsSessionExceptionResponseInput;
  sessionId: Scalars['String'];
};


export type MutationSendJoinDiagnosticsRequestArgs = {
  eveUserId: Scalars['Int'];
  sessionId: Scalars['String'];
};


export type MutationSendJoinMeetingRequestArgs = {
  eveUserName: Scalars['String'];
  mwt: Scalars['String'];
};


export type MutationSendListSipClientLogsRequestArgs = {
  request: ListSipClientLogsRequestInput;
  sessionId: Scalars['String'];
};


export type MutationSendListSipClientLogsResponseArgs = {
  response: ListSipClientLogsResponseInput;
  sessionId: Scalars['String'];
};


export type MutationSendPingRequestArgs = {
  request: PingRequestInput;
  sessionId: Scalars['String'];
};


export type MutationSendPingResponseArgs = {
  response: PingResponseInput;
  sessionId: Scalars['String'];
};


export type MutationSendRefreshTokenArgs = {
  sendRefreshTokenInput: SendRefreshTokenInput;
};


export type MutationSendUploadSipClientLogRequestArgs = {
  request: UploadSipClientLogsRequestInput;
  sessionId: Scalars['String'];
};


export type MutationSendUploadSipClientLogResponseArgs = {
  response: UploadSipClientLogsResponseInput;
  sessionId: Scalars['String'];
};


export type MutationUpdateActivityDiversionMappingArgs = {
  input: ActivityDiversionMappingInput;
};


export type MutationUpdateCallQueueArgs = {
  updateCallQueueInput: CallQueueInput;
};


export type MutationUpdateCallQueueLoginArgs = {
  eveUserName: Scalars['String'];
  loggedIn: Scalars['Boolean'];
  voipId: Scalars['Int'];
};


export type MutationUpdateCallQueueLoginsArgs = {
  callQueueLoginInputs: Array<CallQueueLoginInput>;
};


export type MutationUpdateCommunicationLogItemArgs = {
  itemId: Scalars['Int'];
  played: Scalars['Boolean'];
  seen: Scalars['Boolean'];
  updateCallItem: Scalars['Boolean'];
};


export type MutationUpdateContactArgs = {
  contact: ContactInput;
};


export type MutationUpdateContactV2Args = {
  contact: ContactInput;
};


export type MutationUpdateEveUserArgs = {
  updateEveUserInput: EveUserInput;
};


export type MutationUpdateInternalNumbersArgs = {
  updateInternalNumberInput: InternalNumberInput;
};


export type MutationUpdateMeetingArgs = {
  meeting?: InputMaybe<MeetingInput>;
};


export type MutationUpdatePromptArgs = {
  updatePromptInput: PromptInput;
};


export type MutationUpdateSipTrunkArgs = {
  updateSipTrunkInput: SipTrunkInput;
};

/** A connection to a list of items. */
export type MyCallQueueLoginsConnection = {
  __typename?: 'MyCallQueueLoginsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<MyCallQueueLoginsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<CallQueueLogin>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type MyCallQueueLoginsEdge = {
  __typename?: 'MyCallQueueLoginsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: CallQueueLogin;
};

export type NullableOfStatusOperationFilterInput = {
  eq?: InputMaybe<Status>;
  in?: InputMaybe<Array<InputMaybe<Status>>>;
  neq?: InputMaybe<Status>;
  nin?: InputMaybe<Array<InputMaybe<Status>>>;
};

export type Number = {
  __typename?: 'Number';
  inUse: Scalars['Boolean'];
  number: Scalars['String'];
  numberId: Scalars['Int'];
  numberTypeId: Scalars['Int'];
  organisationId: Scalars['Int'];
  organisationNode: Scalars['HierarchyId'];
};

export type NumberFilterInput = {
  and?: InputMaybe<Array<NumberFilterInput>>;
  inUse?: InputMaybe<BooleanOperationFilterInput>;
  number?: InputMaybe<StringOperationFilterInput>;
  numberId?: InputMaybe<IntOperationFilterInput>;
  numberTypeId?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<NumberFilterInput>>;
  organisationId?: InputMaybe<IntOperationFilterInput>;
  organisationNode?: InputMaybe<HierarchyIdFilterInput>;
};

export type NumberInput = {
  numberId: Scalars['Int'];
};

export type NumberRange = {
  __typename?: 'NumberRange';
  from: Scalars['String'];
  numberTypeId: Scalars['Int'];
  organisationId: Scalars['Int'];
  to: Scalars['String'];
};

export type NumberSortInput = {
  number?: InputMaybe<SortEnumType>;
};

export type NumberTranslation = {
  __typename?: 'NumberTranslation';
  code: Scalars['String'];
  createDate: Scalars['DateTime'];
  isInbound: Scalars['Boolean'];
  isOutbound: Scalars['Boolean'];
  name: Scalars['String'];
  numberTranslationId: Scalars['Int'];
};

export type NumberTranslationFilterInput = {
  and?: InputMaybe<Array<NumberTranslationFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  createDate?: InputMaybe<DateTimeOperationFilterInput>;
  isInbound?: InputMaybe<BooleanOperationFilterInput>;
  isOutbound?: InputMaybe<BooleanOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  numberTranslationId?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<NumberTranslationFilterInput>>;
};

export type NumberTranslationInput = {
  code: Scalars['String'];
  createDate: Scalars['DateTime'];
  isInbound: Scalars['Boolean'];
  isOutbound: Scalars['Boolean'];
  name: Scalars['String'];
  numberTranslationId: Scalars['Int'];
};

/** A segment of a collection. */
export type NumbersCollectionSegment = {
  __typename?: 'NumbersCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Number>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type Organisation = {
  __typename?: 'Organisation';
  barring084: Scalars['Boolean'];
  barring087: Scalars['Boolean'];
  barringDirectory: Scalars['Boolean'];
  barringFreephone: Scalars['Boolean'];
  barringInternational: Scalars['Boolean'];
  barringInternationalPremium: Scalars['Boolean'];
  barringLocal: Scalars['Boolean'];
  barringMobile: Scalars['Boolean'];
  barringPremium: Scalars['Boolean'];
  name: Scalars['String'];
  organisationId: Scalars['Int'];
  organisationNode: Scalars['HierarchyId'];
};

export type OrganisationFilterInput = {
  and?: InputMaybe<Array<OrganisationFilterInput>>;
  barring084?: InputMaybe<BooleanOperationFilterInput>;
  barring087?: InputMaybe<BooleanOperationFilterInput>;
  barringDirectory?: InputMaybe<BooleanOperationFilterInput>;
  barringFreephone?: InputMaybe<BooleanOperationFilterInput>;
  barringInternational?: InputMaybe<BooleanOperationFilterInput>;
  barringInternationalPremium?: InputMaybe<BooleanOperationFilterInput>;
  barringLocal?: InputMaybe<BooleanOperationFilterInput>;
  barringMobile?: InputMaybe<BooleanOperationFilterInput>;
  barringPremium?: InputMaybe<BooleanOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<OrganisationFilterInput>>;
  organisationId?: InputMaybe<IntOperationFilterInput>;
  organisationNode?: InputMaybe<HierarchyIdFilterInput>;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** Indicates whether more edges exist following the set defined by the clients arguments. */
  hasNextPage: Scalars['Boolean'];
  /** Indicates whether more edges exist prior the set defined by the clients arguments. */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

export type PingRequest = IDiagnosticsSessionRequest & {
  __typename?: 'PingRequest';
  host: Scalars['String'];
  requestId: Scalars['String'];
};

export type PingRequestInput = {
  host: Scalars['String'];
  requestId: Scalars['String'];
};

export type PingResponse = IDiagnosticsSessionResponse & {
  __typename?: 'PingResponse';
  address: Scalars['String'];
  dontFragment: Scalars['Boolean'];
  pingStatus: IpStatus;
  requestId: Scalars['String'];
  roundtripTime: Scalars['Long'];
  status: HttpStatusCode;
  ttl: Scalars['Int'];
};

export type PingResponseInput = {
  address: Scalars['String'];
  dontFragment: Scalars['Boolean'];
  pingStatus: IpStatus;
  requestId: Scalars['String'];
  roundtripTime: Scalars['Long'];
  status: HttpStatusCode;
  ttl: Scalars['Int'];
};

export type Prompt = {
  __typename?: 'Prompt';
  description: Scalars['String'];
  library: Library;
  name: Scalars['String'];
  organisationNode: Scalars['HierarchyId'];
  promptId: Scalars['Int'];
};

export type PromptFilterInput = {
  and?: InputMaybe<Array<PromptFilterInput>>;
  description?: InputMaybe<StringOperationFilterInput>;
  library?: InputMaybe<LibraryFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<PromptFilterInput>>;
  organisationNode?: InputMaybe<HierarchyIdFilterInput>;
  promptId?: InputMaybe<IntOperationFilterInput>;
};

export type PromptInput = {
  description?: InputMaybe<Scalars['String']>;
  libraryId?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  organisationNode?: InputMaybe<Scalars['HierarchyId']>;
  promptId?: InputMaybe<Scalars['Int']>;
};

export type PromptSelectionInput = {
  promptId: Scalars['Int'];
};

export type PromptSortInput = {
  name?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type PromptsCollectionSegment = {
  __typename?: 'PromptsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Prompt>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type Query = {
  __typename?: 'Query';
  acdAttendantGroup: AcdAttendantGroup;
  activityDiversions?: Maybe<ActivityDiversionsCollectionSegment>;
  availableAreas: Array<Scalars['String']>;
  availableOrdersByArea: Array<AvailableDdiModel>;
  bankHolidays?: Maybe<BankHolidaysConnection>;
  callQueue?: Maybe<CallQueue>;
  callQueues?: Maybe<CallQueuesConnection>;
  checkResevedNumber: Array<Scalars['Boolean']>;
  communicationLog: CommunicationLog;
  companies?: Maybe<CompaniesCollectionSegment>;
  company?: Maybe<Company>;
  contacts?: Maybe<ContactsCollectionSegment>;
  currentEveUser?: Maybe<EveUser>;
  currentEveUserCustomPresentationGroups?: Maybe<CurrentEveUserCustomPresentationGroupsCollectionSegment>;
  destination?: Maybe<Destination>;
  destinations?: Maybe<DestinationsCollectionSegment>;
  eveUsers?: Maybe<EveUsersCollectionSegment>;
  externalCalendarEvents: Array<ExternalCalendarEvent>;
  externalCalendars: Array<ExternalCalendar>;
  groupInboxLog: CommunicationLog;
  internalNumberRanges: Array<NumberRange>;
  meeting?: Maybe<Meeting>;
  meetings?: Maybe<MeetingsCollectionSegment>;
  myCallQueueLogins?: Maybe<MyCallQueueLoginsConnection>;
  numberTranslations: Array<NumberTranslation>;
  numbers?: Maybe<NumbersCollectionSegment>;
  organisation?: Maybe<Organisation>;
  prompt?: Maybe<Prompt>;
  prompts?: Maybe<PromptsCollectionSegment>;
  queueStatistics: QueueStatistics;
  reservedNumbers: Array<Scalars['String']>;
  sipTrunk?: Maybe<SipTrunk>;
  systemParameter?: Maybe<SystemParameter>;
  timeZones?: Maybe<TimeZonesCollectionSegment>;
  userNamePassword: KeyValuePairOfStringAndString;
};


export type QueryActivityDiversionsArgs = {
  order?: InputMaybe<Array<ActivityDiversionSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ActivityDiversionFilterInput>;
};


export type QueryAvailableOrdersByAreaArgs = {
  filter: AreaNumbersFilterInput;
};


export type QueryBankHolidaysArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<BankHolidaySortInput>>;
  where?: InputMaybe<BankHolidayFilterInput>;
};


export type QueryCallQueueArgs = {
  where?: InputMaybe<CallQueueFilterInput>;
};


export type QueryCallQueuesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<CallQueueSortInput>>;
  where?: InputMaybe<CallQueueFilterInput>;
};


export type QueryCheckResevedNumberArgs = {
  list: Array<Scalars['String']>;
};


export type QueryCommunicationLogArgs = {
  itemTypes?: InputMaybe<Array<Scalars['String']>>;
  limit: Scalars['Int'];
  olderThan?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  since?: InputMaybe<Scalars['Int']>;
};


export type QueryCompaniesArgs = {
  order?: InputMaybe<Array<CompanySortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CompanyFilterInput>;
};


export type QueryCompanyArgs = {
  where?: InputMaybe<CompanyFilterInput>;
};


export type QueryContactsArgs = {
  order?: InputMaybe<Array<ContactSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ContactFilterInput>;
};


export type QueryCurrentEveUserCustomPresentationGroupsArgs = {
  order?: InputMaybe<Array<CustomPresentationGroupSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CustomPresentationGroupFilterInput>;
};


export type QueryDestinationArgs = {
  where?: InputMaybe<DestinationFilterInput>;
};


export type QueryDestinationsArgs = {
  order?: InputMaybe<Array<DestinationSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<DestinationFilterInput>;
};


export type QueryEveUsersArgs = {
  order?: InputMaybe<Array<EveUserSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<EveUserFilterInput>;
};


export type QueryExternalCalendarEventsArgs = {
  endDate: Scalars['DateTime'];
  startDate: Scalars['DateTime'];
};


export type QueryInternalNumberRangesArgs = {
  organisationId: Scalars['Int'];
};


export type QueryMeetingArgs = {
  order?: InputMaybe<Array<MeetingSortInput>>;
  where?: InputMaybe<MeetingFilterInput>;
};


export type QueryMeetingsArgs = {
  order?: InputMaybe<Array<MeetingSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MeetingFilterInput>;
};


export type QueryMyCallQueueLoginsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<CallQueueLoginSortInput>>;
  where?: InputMaybe<CallQueueLoginFilterInput>;
};


export type QueryNumberTranslationsArgs = {
  where?: InputMaybe<NumberTranslationFilterInput>;
};


export type QueryNumbersArgs = {
  order?: InputMaybe<Array<NumberSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<NumberFilterInput>;
};


export type QueryOrganisationArgs = {
  where?: InputMaybe<OrganisationFilterInput>;
};


export type QueryPromptArgs = {
  order?: InputMaybe<Array<PromptSortInput>>;
  where?: InputMaybe<PromptFilterInput>;
};


export type QueryPromptsArgs = {
  order?: InputMaybe<Array<PromptSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PromptFilterInput>;
};


export type QuerySipTrunkArgs = {
  where?: InputMaybe<SipTrunkFilterInput>;
};


export type QuerySystemParameterArgs = {
  where?: InputMaybe<SystemParameterFilterInput>;
};


export type QueryTimeZonesArgs = {
  order?: InputMaybe<Array<TimeZoneSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TimeZoneFilterInput>;
};

export type Queue = {
  __typename?: 'Queue';
  answeredCallsForPeriod: Scalars['Int'];
  answeredCallsLast24h: Scalars['Int'];
  availableAgents: Scalars['Int'];
  averageWait: Scalars['Int'];
  currentagentpresence: Array<CurrentAgentPresence>;
  domain: Scalars['String'];
  droppedCallsForPeriod: Scalars['Int'];
  droppedCallsLast24h: Scalars['Int'];
  id: Scalars['Int'];
  lastWait: Scalars['Int'];
  loggedInAgents: Scalars['Int'];
  longestWaiting: Scalars['Int'];
  name: Scalars['String'];
  number: Scalars['String'];
  queueLength: Scalars['Int'];
  totalCallsForPeriod: Scalars['Int'];
  totalCallsLast24h: Scalars['Int'];
};

export type QueueStatistics = {
  __typename?: 'QueueStatistics';
  queue: Array<Queue>;
};

export type Remoteparty = {
  __typename?: 'Remoteparty';
  contactId?: Maybe<Scalars['String']>;
  displayName: Scalars['String'];
  number?: Maybe<Scalars['String']>;
};

export type Role = {
  __typename?: 'Role';
  type: Scalars['String'];
};

export type Schedule = {
  __typename?: 'Schedule';
  bankHolidays: Array<BankHoliday>;
  dateFrom?: Maybe<Scalars['DateTime']>;
  dateTo?: Maybe<Scalars['DateTime']>;
  forwardDestination?: Maybe<Destination>;
  friday: Scalars['Boolean'];
  monday: Scalars['Boolean'];
  priority: Scalars['Int'];
  prompt?: Maybe<Prompt>;
  saturday: Scalars['Boolean'];
  scheduleAction: ScheduleAction;
  scheduleId: Scalars['Int'];
  scheduleType: ScheduleType;
  sunday: Scalars['Boolean'];
  thursday: Scalars['Boolean'];
  timeFrom?: Maybe<Scalars['TimeSpan']>;
  timeTo?: Maybe<Scalars['TimeSpan']>;
  timeZoneString: Scalars['String'];
  tuesday: Scalars['Boolean'];
  wednesday: Scalars['Boolean'];
};

export enum ScheduleAction {
  Closed = 'CLOSED',
  Forward = 'FORWARD',
  Open = 'OPEN'
}

export type ScheduleActionOperationFilterInput = {
  eq?: InputMaybe<ScheduleAction>;
  in?: InputMaybe<Array<ScheduleAction>>;
  neq?: InputMaybe<ScheduleAction>;
  nin?: InputMaybe<Array<ScheduleAction>>;
};

export type ScheduleFilterInput = {
  and?: InputMaybe<Array<ScheduleFilterInput>>;
  bankHolidays?: InputMaybe<ListFilterInputTypeOfBankHolidayFilterInput>;
  dateFrom?: InputMaybe<DateTimeOperationFilterInput>;
  dateTo?: InputMaybe<DateTimeOperationFilterInput>;
  forwardDestination?: InputMaybe<DestinationFilterInput>;
  friday?: InputMaybe<BooleanOperationFilterInput>;
  monday?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<ScheduleFilterInput>>;
  priority?: InputMaybe<IntOperationFilterInput>;
  prompt?: InputMaybe<PromptFilterInput>;
  saturday?: InputMaybe<BooleanOperationFilterInput>;
  scheduleAction?: InputMaybe<ScheduleActionOperationFilterInput>;
  scheduleId?: InputMaybe<IntOperationFilterInput>;
  scheduleType?: InputMaybe<ScheduleTypeOperationFilterInput>;
  sunday?: InputMaybe<BooleanOperationFilterInput>;
  thursday?: InputMaybe<BooleanOperationFilterInput>;
  timeFrom?: InputMaybe<TimeSpanOperationFilterInput>;
  timeTo?: InputMaybe<TimeSpanOperationFilterInput>;
  timeZoneString?: InputMaybe<StringOperationFilterInput>;
  tuesday?: InputMaybe<BooleanOperationFilterInput>;
  wednesday?: InputMaybe<BooleanOperationFilterInput>;
};

export type ScheduleInput = {
  bankHolidays?: InputMaybe<Array<BankHolidayInput>>;
  dateFrom?: InputMaybe<Scalars['DateTime']>;
  dateTo?: InputMaybe<Scalars['DateTime']>;
  forwardDestination?: InputMaybe<DestinationInput>;
  friday?: InputMaybe<Scalars['Boolean']>;
  monday?: InputMaybe<Scalars['Boolean']>;
  priority?: InputMaybe<Scalars['Int']>;
  prompt?: InputMaybe<PromptSelectionInput>;
  saturday?: InputMaybe<Scalars['Boolean']>;
  scheduleAction?: InputMaybe<ScheduleAction>;
  scheduleId?: InputMaybe<Scalars['Int']>;
  scheduleType?: InputMaybe<ScheduleType>;
  sunday?: InputMaybe<Scalars['Boolean']>;
  thursday?: InputMaybe<Scalars['Boolean']>;
  timeFrom?: InputMaybe<Scalars['TimeSpan']>;
  timeTo?: InputMaybe<Scalars['TimeSpan']>;
  timeZoneString?: InputMaybe<Scalars['String']>;
  tuesday?: InputMaybe<Scalars['Boolean']>;
  wednesday?: InputMaybe<Scalars['Boolean']>;
};

export enum ScheduleType {
  BankHoliday = 'BANK_HOLIDAY',
  Date = 'DATE',
  Recurring = 'RECURRING'
}

export type ScheduleTypeOperationFilterInput = {
  eq?: InputMaybe<ScheduleType>;
  in?: InputMaybe<Array<ScheduleType>>;
  neq?: InputMaybe<ScheduleType>;
  nin?: InputMaybe<Array<ScheduleType>>;
};

export type SendRefreshTokenInput = {
  eveUserId: Scalars['Int'];
};

export type SipClientLog = {
  __typename?: 'SipClientLog';
  fileName: Scalars['String'];
  size: Scalars['Long'];
};

export type SipClientLogInput = {
  fileName: Scalars['String'];
  size: Scalars['Long'];
};

export type SipTrunk = {
  __typename?: 'SipTrunk';
  authenticationPassword: Scalars['String'];
  authenticationType: AuthenticationOptionsType;
  authenticationUsername: Scalars['String'];
  barring084: Scalars['Boolean'];
  barring087: Scalars['Boolean'];
  barringDirectory: Scalars['Boolean'];
  barringFreephone: Scalars['Boolean'];
  barringInternational: Scalars['Boolean'];
  barringInternationalPremium: Scalars['Boolean'];
  barringLocal: Scalars['Boolean'];
  barringMobile: Scalars['Boolean'];
  barringPremium: Scalars['Boolean'];
  busyOnChannelsExceeded?: Maybe<Scalars['Boolean']>;
  callRecording: CallRecording;
  channels: Scalars['Int'];
  inboundChannelsLimit?: Maybe<Scalars['Int']>;
  inboundTranslation?: Maybe<NumberTranslation>;
  ipAddress: Scalars['String'];
  isSbcVersionOld: Scalars['Boolean'];
  mainSipNumber: SipTrunkNumberModel;
  name: Scalars['String'];
  number: Number;
  organisationId: Scalars['Int'];
  organisationNode: Scalars['HierarchyId'];
  outboundChannelsLimit?: Maybe<Scalars['Int']>;
  sipTrunkId: Scalars['Int'];
  sipTrunkNumbers: Array<SipTrunkNumberModel>;
  sipTrunkPresentation: SipTrunkPresentationType;
};

export type SipTrunkFilterInput = {
  and?: InputMaybe<Array<SipTrunkFilterInput>>;
  authenticationPassword?: InputMaybe<StringOperationFilterInput>;
  authenticationType?: InputMaybe<AuthenticationOptionsTypeOperationFilterInput>;
  authenticationUsername?: InputMaybe<StringOperationFilterInput>;
  barring084?: InputMaybe<BooleanOperationFilterInput>;
  barring087?: InputMaybe<BooleanOperationFilterInput>;
  barringDirectory?: InputMaybe<BooleanOperationFilterInput>;
  barringFreephone?: InputMaybe<BooleanOperationFilterInput>;
  barringInternational?: InputMaybe<BooleanOperationFilterInput>;
  barringInternationalPremium?: InputMaybe<BooleanOperationFilterInput>;
  barringLocal?: InputMaybe<BooleanOperationFilterInput>;
  barringMobile?: InputMaybe<BooleanOperationFilterInput>;
  barringPremium?: InputMaybe<BooleanOperationFilterInput>;
  busyOnChannelsExceeded?: InputMaybe<BooleanOperationFilterInput>;
  callRecording?: InputMaybe<CallRecordingOperationFilterInput>;
  channels?: InputMaybe<IntOperationFilterInput>;
  inboundChannelsLimit?: InputMaybe<IntOperationFilterInput>;
  inboundTranslation?: InputMaybe<NumberTranslationFilterInput>;
  ipAddress?: InputMaybe<StringOperationFilterInput>;
  isSbcVersionOld?: InputMaybe<BooleanOperationFilterInput>;
  mainSipNumber?: InputMaybe<SipTrunkNumberModelFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  number?: InputMaybe<NumberFilterInput>;
  or?: InputMaybe<Array<SipTrunkFilterInput>>;
  organisationId?: InputMaybe<IntOperationFilterInput>;
  organisationNode?: InputMaybe<HierarchyIdFilterInput>;
  outboundChannelsLimit?: InputMaybe<IntOperationFilterInput>;
  sipTrunkId?: InputMaybe<IntOperationFilterInput>;
  sipTrunkNumbers?: InputMaybe<ListFilterInputTypeOfSipTrunkNumberModelFilterInput>;
  sipTrunkPresentation?: InputMaybe<SipTrunkPresentationTypeOperationFilterInput>;
};

export type SipTrunkInput = {
  addSipTrunkNumbers?: InputMaybe<Array<SipTrunkNumberInput>>;
  authenticationPassword?: InputMaybe<Scalars['String']>;
  authenticationType?: InputMaybe<AuthenticationOptionsType>;
  authenticationUsername?: InputMaybe<Scalars['String']>;
  barring084?: InputMaybe<Scalars['Boolean']>;
  barringDirectory?: InputMaybe<Scalars['Boolean']>;
  barringFreephone?: InputMaybe<Scalars['Boolean']>;
  barringInternational?: InputMaybe<Scalars['Boolean']>;
  barringLocal?: InputMaybe<Scalars['Boolean']>;
  barringMobile?: InputMaybe<Scalars['Boolean']>;
  barringPremium?: InputMaybe<Scalars['Boolean']>;
  busyOnChannelsExceeded?: InputMaybe<Scalars['Boolean']>;
  callRecording?: InputMaybe<CallRecording>;
  channels?: InputMaybe<Scalars['Int']>;
  deleteSipTrunkNumbers?: InputMaybe<Array<SipTrunkNumberInput>>;
  inboundChannelsLimit?: InputMaybe<Scalars['Int']>;
  inboundTranslation?: InputMaybe<NumberTranslationInput>;
  ipAddress?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<NumberInput>;
  organisationId?: InputMaybe<Scalars['Int']>;
  organisationNode?: InputMaybe<Scalars['HierarchyId']>;
  outboundChannelsLimit?: InputMaybe<Scalars['Int']>;
  sipTrunkId?: InputMaybe<Scalars['Int']>;
  sipTrunkPresentation?: InputMaybe<SipTrunkPresentationType>;
  updateSipTrunkNumbers?: InputMaybe<Array<SipTrunkNumberInput>>;
};

export type SipTrunkNumberInput = {
  divertNumber?: InputMaybe<Scalars['String']>;
  failoverNumber?: InputMaybe<Scalars['String']>;
  isDiverted: Scalars['Boolean'];
  numberId: Scalars['Int'];
  sipTrunkId?: InputMaybe<Scalars['Int']>;
  sipTrunkNumberId?: InputMaybe<Scalars['Int']>;
};

export type SipTrunkNumberModel = {
  __typename?: 'SipTrunkNumberModel';
  divertNumber?: Maybe<Scalars['String']>;
  failoverNumber?: Maybe<Scalars['String']>;
  isDiverted: Scalars['Boolean'];
  number: Scalars['String'];
  numberId: Scalars['Int'];
  sipTrunkNumberId?: Maybe<Scalars['Int']>;
};

export type SipTrunkNumberModelFilterInput = {
  and?: InputMaybe<Array<SipTrunkNumberModelFilterInput>>;
  divertNumber?: InputMaybe<StringOperationFilterInput>;
  failoverNumber?: InputMaybe<StringOperationFilterInput>;
  isDiverted?: InputMaybe<BooleanOperationFilterInput>;
  number?: InputMaybe<StringOperationFilterInput>;
  numberId?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<SipTrunkNumberModelFilterInput>>;
  sipTrunkNumberId?: InputMaybe<IntOperationFilterInput>;
};

export enum SipTrunkPresentationType {
  Anonymous = 'ANONYMOUS',
  Passthrough = 'PASSTHROUGH',
  UserDefined = 'USER_DEFINED'
}

export type SipTrunkPresentationTypeOperationFilterInput = {
  eq?: InputMaybe<SipTrunkPresentationType>;
  in?: InputMaybe<Array<SipTrunkPresentationType>>;
  neq?: InputMaybe<SipTrunkPresentationType>;
  nin?: InputMaybe<Array<SipTrunkPresentationType>>;
};

export enum SortEnumType {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type Statistic = {
  __typename?: 'Statistic';
  numberOfCallsInQueue: Scalars['Int'];
  numberOfFreeAgents: Scalars['Int'];
  numberOfLoggedInAgents: Scalars['Int'];
};

export enum Status {
  Available = 'AVAILABLE',
  Busy = 'BUSY',
  Holiday = 'HOLIDAY',
  Lunch = 'LUNCH',
  Meeting = 'MEETING',
  OutOfOffice = 'OUT_OF_OFFICE'
}

export type StatusOperationFilterInput = {
  eq?: InputMaybe<Status>;
  in?: InputMaybe<Array<Status>>;
  neq?: InputMaybe<Status>;
  nin?: InputMaybe<Array<Status>>;
};

export type StringOperationFilterInput = {
  and?: InputMaybe<Array<StringOperationFilterInput>>;
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  eq?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ncontains?: InputMaybe<Scalars['String']>;
  nendsWith?: InputMaybe<Scalars['String']>;
  neq?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nstartsWith?: InputMaybe<Scalars['String']>;
  or?: InputMaybe<Array<StringOperationFilterInput>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  diagnosticsSessionRequest: IDiagnosticsSessionRequest;
  diagnosticsSessionResponse: IDiagnosticsSessionResponse;
  joinDiagnosticsRequest: IJoinDiagnosticsRequest;
  joinMeetingRequest: MeetingRequest;
  meetingEvent: MeetingEvent;
};


export type SubscriptionDiagnosticsSessionRequestArgs = {
  sessionId: Scalars['String'];
};


export type SubscriptionDiagnosticsSessionResponseArgs = {
  sessionId: Scalars['String'];
};

export type SystemParameter = {
  __typename?: 'SystemParameter';
  id: Scalars['Int'];
  name: Scalars['String'];
  value: Scalars['String'];
};

export type SystemParameterFilterInput = {
  and?: InputMaybe<Array<SystemParameterFilterInput>>;
  id?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<SystemParameterFilterInput>>;
  value?: InputMaybe<StringOperationFilterInput>;
};

export type TimeSpanOperationFilterInput = {
  eq?: InputMaybe<Scalars['TimeSpan']>;
  gt?: InputMaybe<Scalars['TimeSpan']>;
  gte?: InputMaybe<Scalars['TimeSpan']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['TimeSpan']>>>;
  lt?: InputMaybe<Scalars['TimeSpan']>;
  lte?: InputMaybe<Scalars['TimeSpan']>;
  neq?: InputMaybe<Scalars['TimeSpan']>;
  ngt?: InputMaybe<Scalars['TimeSpan']>;
  ngte?: InputMaybe<Scalars['TimeSpan']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['TimeSpan']>>>;
  nlt?: InputMaybe<Scalars['TimeSpan']>;
  nlte?: InputMaybe<Scalars['TimeSpan']>;
};

export type TimeZone = {
  __typename?: 'TimeZone';
  code: Scalars['String'];
  name: Scalars['String'];
  timeZoneId?: Maybe<Scalars['Int']>;
};

export type TimeZoneFilterInput = {
  and?: InputMaybe<Array<TimeZoneFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TimeZoneFilterInput>>;
  timeZoneId?: InputMaybe<IntOperationFilterInput>;
};

export type TimeZoneSortInput = {
  code?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  timeZoneId?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type TimeZonesCollectionSegment = {
  __typename?: 'TimeZonesCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<TimeZone>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type UploadSipClientLogsRequest = IDiagnosticsSessionRequest & {
  __typename?: 'UploadSipClientLogsRequest';
  fileName: Scalars['String'];
  requestId: Scalars['String'];
};

export type UploadSipClientLogsRequestInput = {
  fileName: Scalars['String'];
  requestId: Scalars['String'];
};

export type UploadSipClientLogsResponse = IDiagnosticsSessionResponse & {
  __typename?: 'UploadSipClientLogsResponse';
  block?: Maybe<Array<Scalars['Byte']>>;
  requestId: Scalars['String'];
  seq: Scalars['Int'];
  status: HttpStatusCode;
};

export type UploadSipClientLogsResponseInput = {
  block?: InputMaybe<Array<Scalars['Byte']>>;
  requestId: Scalars['String'];
  seq: Scalars['Int'];
  status: HttpStatusCode;
};

export enum UserLevel {
  Account = 'ACCOUNT',
  Brand = 'BRAND',
  Client = 'CLIENT',
  Company = 'COMPANY',
  EndUser = 'END_USER',
  EveNetworks = 'EVE_NETWORKS',
  None = 'NONE',
  Reseller = 'RESELLER',
  Site = 'SITE',
  SuperUser = 'SUPER_USER',
  Wholesaler = 'WHOLESALER'
}

export type UserLevelOperationFilterInput = {
  eq?: InputMaybe<UserLevel>;
  in?: InputMaybe<Array<UserLevel>>;
  neq?: InputMaybe<UserLevel>;
  nin?: InputMaybe<Array<UserLevel>>;
};

export type UuidOperationFilterInput = {
  eq?: InputMaybe<Scalars['UUID']>;
  gt?: InputMaybe<Scalars['UUID']>;
  gte?: InputMaybe<Scalars['UUID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  lt?: InputMaybe<Scalars['UUID']>;
  lte?: InputMaybe<Scalars['UUID']>;
  neq?: InputMaybe<Scalars['UUID']>;
  ngt?: InputMaybe<Scalars['UUID']>;
  ngte?: InputMaybe<Scalars['UUID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  nlt?: InputMaybe<Scalars['UUID']>;
  nlte?: InputMaybe<Scalars['UUID']>;
};

export type Voicemaildto = {
  __typename?: 'Voicemaildto';
  callItemId: Scalars['Int'];
  click2CallUrl: Scalars['String'];
  isPlayed: Scalars['Boolean'];
  isSeen: Scalars['Boolean'];
  itemId: Scalars['Int'];
  itemType: Scalars['String'];
  remoteParty: Remoteparty;
  startTime: Scalars['DateTime'];
  url: Scalars['String'];
};

export type GetCommunicationLogQueryVariables = Exact<{
  limit: Scalars['Int'];
  itemTypes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  since?: InputMaybe<Scalars['Int']>;
  olderThan?: InputMaybe<Scalars['Int']>;
}>;


export type GetCommunicationLogQuery = { __typename?: 'Query', communicationLog: { __typename?: 'CommunicationLog', historyItems: Array<{ __typename?: 'Historyitem', callDTO?: { __typename?: 'Calldto', itemId: number, startTime: any, duration: number, itemType: string, isSeen: boolean, remoteParty: { __typename?: 'Remoteparty', contactId?: string | null, number?: string | null, displayName: string } } | null, voiceMailDTO?: { __typename?: 'Voicemaildto', itemId: number, startTime: any, itemType: string, isPlayed: boolean, url: string, click2CallUrl: string, remoteParty: { __typename?: 'Remoteparty', contactId?: string | null, number?: string | null, displayName: string } } | null }> } };

export type ContactFragment = { __typename?: 'Contact', contactId: number, firstName: string, surname: string, email?: string | null, phoneNumber?: string | null, favourite: boolean, avatarImageId?: number | null, eveUserId?: number | null, eveUserName?: string | null, number?: string | null, internalNumber?: string | null, organisationNode?: any | null };

export type GetContactsQueryVariables = Exact<{
  filter: ContactFilterInput;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
}>;


export type GetContactsQuery = { __typename?: 'Query', contacts?: { __typename?: 'ContactsCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'Contact', contactId: number, firstName: string, surname: string, email?: string | null, phoneNumber?: string | null, favourite: boolean, avatarImageId?: number | null, eveUserId?: number | null, eveUserName?: string | null, number?: string | null, internalNumber?: string | null, organisationNode?: any | null }> | null } | null };

export type LoginResultFragment = { __typename?: 'LoginResult', jwt: string, salt: string, sipUrl: string, sipUserName: string, sipPassword: string, eveUser: { __typename?: 'EveUser', eveUserId: number, eveUserName: string, firstName: string, surname: string } };

export type LoginRefreshTokenMutationVariables = Exact<{
  refreshToken: Scalars['String'];
}>;


export type LoginRefreshTokenMutation = { __typename?: 'Mutation', loginRefreshToken?: { __typename?: 'LoginResult', jwt: string, salt: string, sipUrl: string, sipUserName: string, sipPassword: string, eveUser: { __typename?: 'EveUser', eveUserId: number, eveUserName: string, firstName: string, surname: string } } | null };

export type LoginV2MutationVariables = Exact<{
  user: Scalars['String'];
  password: Scalars['String'];
  deviceName: Scalars['String'];
}>;


export type LoginV2Mutation = { __typename?: 'Mutation', loginV2?: string | null };

export type UpdateCallQueueLoginMutationVariables = Exact<{
  logins: CallQueueLoginInput;
}>;


export type UpdateCallQueueLoginMutation = { __typename?: 'Mutation', updateCallQueueLogins: Array<{ __typename?: 'CallQueueLogin', callQueueId: number, name: string, isLoggedIn: boolean }> };

export type GetUserCallQueueLoginsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserCallQueueLoginsQuery = { __typename?: 'Query', myCallQueueLogins?: { __typename?: 'MyCallQueueLoginsConnection', nodes?: Array<{ __typename?: 'CallQueueLogin', callQueueId: number, name: string, isLoggedIn: boolean }> | null } | null };

export const ContactFragmentDoc = gql`
    fragment contact on Contact {
  contactId
  firstName
  surname
  email
  phoneNumber
  favourite
  avatarImageId
  eveUserId
  eveUserName
  number
  internalNumber
  organisationNode
}
    `;
export const LoginResultFragmentDoc = gql`
    fragment loginResult on LoginResult {
  jwt
  salt
  sipUrl
  sipUserName
  sipPassword
  eveUser {
    eveUserId
    eveUserName
    firstName
    surname
  }
}
    `;
export const GetCommunicationLogDocument = gql`
    query GetCommunicationLog($limit: Int!, $itemTypes: [String!], $search: String, $since: Int, $olderThan: Int) {
  communicationLog(
    limit: $limit
    itemTypes: $itemTypes
    search: $search
    since: $since
    olderThan: $olderThan
  ) {
    historyItems {
      callDTO {
        itemId
        startTime
        remoteParty {
          contactId
          number
          displayName
        }
        duration
        itemType
        isSeen
      }
      voiceMailDTO {
        itemId
        startTime
        remoteParty {
          contactId
          number
          displayName
        }
        itemType
        isPlayed
        url
        click2CallUrl
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCommunicationLogGQL extends Apollo.Query<GetCommunicationLogQuery, GetCommunicationLogQueryVariables> {
    override document = GetCommunicationLogDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetContactsDocument = gql`
    query GetContacts($filter: ContactFilterInput!, $skip: Int, $take: Int) {
  contacts(
    where: $filter
    skip: $skip
    take: $take
    order: [{firstName: ASC}, {surname: ASC}]
  ) {
    items {
      ...contact
    }
    totalCount
  }
}
    ${ContactFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetContactsGQL extends Apollo.Query<GetContactsQuery, GetContactsQueryVariables> {
    override document = GetContactsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoginRefreshTokenDocument = gql`
    mutation LoginRefreshToken($refreshToken: String!) {
  loginRefreshToken(refreshToken: $refreshToken) {
    ...loginResult
  }
}
    ${LoginResultFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LoginRefreshTokenGQL extends Apollo.Mutation<LoginRefreshTokenMutation, LoginRefreshTokenMutationVariables> {
    override document = LoginRefreshTokenDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoginV2Document = gql`
    mutation LoginV2($user: String!, $password: String!, $deviceName: String!) {
  loginV2(user: $user, password: $password, deviceName: $deviceName)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LoginV2GQL extends Apollo.Mutation<LoginV2Mutation, LoginV2MutationVariables> {
    override document = LoginV2Document;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCallQueueLoginDocument = gql`
    mutation UpdateCallQueueLogin($logins: CallQueueLoginInput!) {
  updateCallQueueLogins(callQueueLoginInputs: [$logins]) {
    callQueueId
    name
    isLoggedIn
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCallQueueLoginGQL extends Apollo.Mutation<UpdateCallQueueLoginMutation, UpdateCallQueueLoginMutationVariables> {
    override document = UpdateCallQueueLoginDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetUserCallQueueLoginsDocument = gql`
    query GetUserCallQueueLogins {
  myCallQueueLogins {
    nodes {
      callQueueId
      name
      isLoggedIn
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetUserCallQueueLoginsGQL extends Apollo.Query<GetUserCallQueueLoginsQuery, GetUserCallQueueLoginsQueryVariables> {
    override document = GetUserCallQueueLoginsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }